export default __webpack_public_path__ + "static/media/datepicker-arrow-right.466c1bda.svg";